import axios from "../config/axios";
import config from "../config/index";

/**
 * Build GET path for turbo config.
 * Legacy: get-turbo-config/{userId}
 * Extended: get-turbo-config/{userId}?workspace_id=...&bot_type=...&test_mode=1
 */
const buildTurboConfigPath = (params) => {
    if (typeof params === "object" && params !== null) {
        const { userId, workspace_id, bot_type, test_mode } = params;
        const query = new URLSearchParams();
        if (workspace_id !== undefined && workspace_id !== null && workspace_id !== "") {
            query.set("workspace_id", workspace_id);
        }
        if (bot_type) {
            query.set("bot_type", bot_type);
        }
        if (test_mode !== undefined && test_mode !== null && test_mode !== "") {
            query.set("test_mode", String(test_mode));
        }
        return `${config.apiBaseURL2}get-turbo-config/${userId}${query.toString() ? `?${query.toString()}` : ""}`;
    }
    return `${config.apiBaseURL2}get-turbo-config/${params}`;
};

const botbuilder = {

    getLists: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/getlist`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteworkspace: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/deleteworkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    updateWorkspace: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/updateWorkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    updateWorkspaceName: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/updateworkspacename`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteWorkspace: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/delketeworkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    duplicateWorkspace: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/duplicateworkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getSearchList: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/getsearchlist`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    getactiveAssistants: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/getactiveAssistant`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),



    viewwokspacedetail: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/viewwokspacedetail`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    createworkspace: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/createworkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    updateposition: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/updateposition`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    copybranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/copybranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    targetedbranchdetail: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/targetedbranchdetail`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deletebranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deletebranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deployworkspace: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deployworkspace`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    responsetime: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/responsetime`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    // Outbound Campaign APIs
    getOutboundCampaigns: (params) =>
        axios
            .post(`/outbound/campaigns/getlist`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    createOutboundCampaign: (params) =>
        axios
            .post(`/outbound/campaigns/create`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    updateOutboundCampaign: (params) =>
        axios
            .post(`/outbound/campaigns/update`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteOutboundCampaign: (params) =>
        axios
            .post(`/outbound/campaigns/delete`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getOutboundCampaignDetails: (params) =>
        axios
            .post(`/outbound/campaigns/details`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveBranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveBranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    editBranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/editBranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveAIRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveAIRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteAIRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteAIRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    updateAIRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/updateAIRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    capturedsave: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/capturedsave`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    captureddelete: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/captureddelete`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    createBranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/createBranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    addNewBranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/addNewBranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    finalSave: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/finalSave`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveQuestionResponse: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveQuestionResponse`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveZapWebhooks: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveZapWebhooks`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    deleteQuestionResponse: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteQuestionResponse`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    deletewebhook: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deletewebhook`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    editQuestionResponse: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/editQuestionResponse`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveMultipleChoice: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveMultipleChoice`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    deleteMultipleChoiceQuestionAll: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteMultipleChoiceQuestionAll`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveBranchLink: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveBranchLink`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getLinkDetails: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getLinkDetails`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteBranchLink: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteBranchLink`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),



    updateBranchTeamNotifyMembers: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/updateBranchTeamNotifyMembers`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getLiveChatRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getLiveChatRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveTimeZoneDataBranch: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveTimeZoneDataBranch`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    resetForm: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/resetForm`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    editBranchEmail: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/editBranchEmail`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteBranchEmail: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteBranchEmail`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getTestingView: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getTestingView`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getWatsonData: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getWatsonData`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    addSuggestedInetentExample: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/addSuggestedInetentExample`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getZipCodeRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getZipCodeRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveZipCodeRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveZipCodeRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    updateBranchforAll: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/updateBranchforAll`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteZipCodeRules: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deleteZipCodeRules`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    acceptAttchmentResponse: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/acceptAttchmentResponse`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getGtmTrigger: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/getGtmTrigger`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveGtmTrigger: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveGtmTrigger`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveZipCodeRulesBulk: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveZipCodeRulesBulk`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deletebulkzip: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/deletebulkzip`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    fetchTrainYourAiData: (param) =>
        axios
            .post('botbuilder/BotBuilderDetail/getTranYourAi', param)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveTrainYourAiData: (param) =>
        axios
            .post('botbuilder/BotBuilderDetail/saveTranYourAi', param)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    savechatReport: (params) =>
        axios
            .post(`/botbuilder/BotBuilderDetail/saveChatReport`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    createChatGptIntegration: (params) =>
        axios
            .post(`/botbuilder/GptChatThirdPartyIntegration/createChatGptIntegration`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    createChatGptIntegrationValue: (params) =>
        axios
            .post(`/botbuilder/GptChatThirdPartyIntegration/createChatGptZpSTIntegrationValue`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getintegrationlist: (params) =>
        axios
            .post(`/botbuilder/GptChatThirdPartyIntegration/getintegrationlist`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteCustomSearchFormIntegration: (params) =>
        axios
            .post(`/botbuilder/GptChatThirdPartyIntegration/deleteCustomSearchFormIntegration`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    changeContextBranchName: (param) =>
        axios
            .post('botbuilder/Botbuilder/changeContext', param)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    servieTitanchatBranchList: (params) =>
        axios
            .post("/botbuilder/Botbuilder/activeBotData", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    servieTitanchatTurboBranchList: (params) =>
        axios
            .post("/botbuilder/Botbuilder/activeBotData", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveStBranchName: (params) =>
        axios
            .post("/botbuilder/Botbuilder/saveStBranch", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    serviceTitanAddedBranchList: (params) =>
        axios
            .post("/botbuilder/Botbuilder/StBranchesList", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    serviceTitanWebDeleteBranch: (params) =>
        axios
            .post("/botbuilder/Botbuilder/deleteSTBranch", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),


    getcallforwarding: (params) =>
        axios
            .post("/botbuilder/Botbuilder/getcallforwarding", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveCallFarwordNumber: (params) =>
        axios
            .post("/botbuilder/Botbuilder/saveCallFarwordNumber", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteCallFarwordNumber: (params) =>
        axios
            .post("/botbuilder/Botbuilder/deleteCallFarwordNumber", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteCallFarword: (params) =>
        axios
            .post("/botbuilder/Botbuilder/deleteCallFarword", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    gettimezoneHourConfigration: () =>
        axios
            .get("/botbuilder/Botbuilder/getTimezoneHourLilst")
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    savetimezoneHourConfigration: (params) =>
        axios
            .post("/botbuilder/Botbuilder/saveTimezoneHourLilst", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    fetchTimezoneHourLilst: (params) =>
        axios
            .post("/botbuilder/Botbuilder/fetchTimezoneHourLilst", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getOccupiedHours: (params) =>
        axios
            .post("/botbuilder/Botbuilder/getOccupiedHours", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getdefaultPauses: (params) =>
        axios
            .get(`${config.apiBaseURL2}admin-pauses`, {})
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getvoicePauses: (params) =>
        axios
            .get(`${config.apiBaseURL2}getvoicePauses?` + params, {})
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    savevoicePauses: (params) =>
        axios
            .post(`${config.apiBaseURL2}savepausesSound`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deletePause: (params) =>
        axios
            .post(`${config.apiBaseURL2}deletePause`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deletedefaultPause: (params) =>
        axios
            .post(`${config.apiBaseURL2}deletedefaultPause`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    addpauseText: (params) =>
        axios
            .post(`${config.apiBaseURL2}addpauseText`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveParseDaataConfigration: (params) => axios
        .post('/botbuilder/BotBuilderDetail/saveParseDataConfigration', params).then((resp) => resp.data)
        .catch((err) => console.log(err)),

    importParseDaataConfigration: (params) => axios
        .post('/botbuilder/BotBuilderDetail/importParseDataConfigration', params).then((resp) => resp.data)
        .catch((err) => console.log(err)),

   
    getHolidaysListForOutbound: (params) => axios
        .post('/botbuilder/Botbuilder/getHolidaysListForOutbound', params).then((resp) => resp.data)
        .catch((err) => console.log(err)),


    getParseDaataConfigration: (params) => axios
        .post('/botbuilder/BotBuilderDetail/fetchturboParsingConfigration', params).then((resp) => resp.data)
        .catch((err) => console.log(err)),

    getKeyPadRules: (params) => axios
        .post('/botbuilder/BotBuilderDetail/getKeyPadRules', params).then((resp) => resp.data)
        .catch((err) => console.log(err)),



    getVoiceWorkspaceBranch: (formData) =>
        axios.post("/settings/voiceNotification/getVoiceWorkspaceBranch", formData),

    getHolidaysList: (params) =>
        axios
            .post("/botbuilder/Botbuilder/getHolidaysList", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    deleteHolidayNode: (paraholidayparams) =>
        axios
            .post("/botbuilder/Botbuilder/deleteHolidayNode", paraholidayparams)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getCurrentTime: (params) =>
        axios
            .post(`botbuilder/BotBuilderDetail/currentTime`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    uploadAudioForWelcome: (formdata) => {
        return new Promise((resolve, reject) => {
            axios
                .post(`botbuilder/BotBuilderDetail/uploadAudio`, formdata, {
                    headers: {
                        'Content-Type': 'multipart/form-data' // Crucial for file uploads
                    }
                })
                .then((resp) => {
                    console.log("succes");
                    if (resp.data) {
                        resolve(resp.data); // Return the response data
                    } else {
                        reject(new Error("No response data received"));
                    }
                })
                .catch((err) => {
                    console.error("Upload failed:", err);
                    reject(err); // Reject the promise if an error occurs
                });
        });
    },


    fetchWorkspaceLogs: (params) =>
        axios.get(`/botbuilder/WorkspaceHistoryLogs/workspaceLogs?` + params, {})
            .then((resp) => resp.data)
            .catch((err) => {
                return { status: false, error: "Something went wrong." };
            }),
    generateGoal: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/generateGoal`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    generateFaqs: (params) =>
        axios
            .post(`/botbuilder/Botbuilder/generateFaqs`, params)
            .then((resp) => resp.data)
            .catch((err) => {
                return { status: false, error: "Something went wrong." };
            }),

    fetchSyncFaqBranchList: (params) =>
        axios.get(`/botbuilder/Botbuilder/syncfaqbranchlist?` + params, {})
            .then((resp) => resp.data)
            .catch((err) => {
                return { status: false, error: "Something went wrong." };
            }),
    revertChanges: (params) =>
        axios
            .post("/botbuilder/BotBuilderDetail/revertChanges", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    saveFaqSync: (params) =>
        axios
            .post("/botbuilder/Botbuilder/saveSyncfaqbranch", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    updatekeypressrule: (params) =>
        axios
            .post("/botbuilder/BotBuilderDetail/updateKeyPadRule", params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getVoiceAndModel: (params) =>
        axios
            .get(`/botbuilder/BotBuilderDetail/voices`)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    /**
     * GET {apiBaseURL2}get-turbo-config/{userId}
     * Used by VapiAssitant (Voice_Turbo "Talk To Assistant" + OUTBOUND "Test Call"):
     *   startCall() → getTurBoConfig(userId) → vapi.start(squadId | data.assistant)
     *
     * params: user id (string|number) appended as path segment only (legacy).
     * Optional backend extension (no breaking change): same path with query string e.g.
     *   ?workspace_id=...&bot_type=OUTBOUND&test_mode=1
     * When extending, change caller to pass URL with query; backend must keep legacy behavior
     * when query params are omitted.
     *
     * Typical success JSON: { status: true, squadId?: string } OR { status: true, data: { assistant, assistantOverrides } }
     * Errors: { status: false, message?: string } (frontend may also read error field)
     */
    getTurBoConfig: (params) =>
        axios
            .get(buildTurboConfigPath(params), {})
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    /** Vapi squad cleanup after test call when squadId was used. POST {apiBaseURL2}squad/{squadId} */
            deleteSquad: (params) =>
        axios
            .post(`${config.apiBaseURL2}squad/`+ params, {})
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    getVapiVariables: (params) =>
        axios
            .post(`${config.apiBaseURL2}vapi-variables/by-type`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    getUserTimezone: (params) =>
        axios
            .post(`${config.apiBaseURL2}vapi-variables/getUserTimezone`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),
    saveUserTimezone: (params) =>
        axios
            .post(`${config.apiBaseURL2}vapi-variables/saveUserTimezone`, params)
            .then((resp) => resp.data)
            .catch((err) => console.log(err)),

    /**
     * Test Call variables (zyra_workspace_test_variables). POST workspace_id → { variables: Record<string,string> }
     */
    getWorkspaceTestVariables: ({ workspace_id }) =>
        axios
            .get(`${config.apiBaseURL2}getWorkspaceTestVariables`, {
                params: { workspace_id },
            })
            .then((resp) => resp.data)
            .catch((err) => {
                console.log(err);
                return { status: false, data: { variables: {}, variable_names: [] } };
            }),

    saveWorkspaceTestVariables: ({ workspace_id, variables }) =>
        axios
            .post(`${config.apiBaseURL2}saveWorkspaceTestVariables`, {
                workspace_id,
                variables: variables || {},
            })
            .then((resp) => resp.data)
            .catch((err) => {
                console.log(err);
                return { status: false, data: { variables: {} } };
            }),

    /** OUTBOUNDSMS: persist test phone number in zyra_outbound_sms_workspace. */
    saveOutboundSmsNumber: ({ workspace_id, phone_number }) =>
        axios
            .post(`${config.apiBaseURL2}saveOutboundSmsNumber`, {
                workspace_id,
                phone_number,
            })
            .then((resp) => resp.data)
            .catch((err) => {
                console.log(err);
                const msg =
                    (err.response && err.response.data && err.response.data.message) ||
                    "Could not save phone number.";
                return { status: false, message: msg, data: {} };
            }),

    getOutboundSmsNumber: ({ workspace_id }) =>
        axios
            .get(`${config.apiBaseURL2}getOutboundSmsNumber`, { params: { workspace_id } })
            .then((resp) => resp.data)
            .catch((err) => {
                console.log(err);
                return { status: false, data: { phone_number: "", outboundsms_deploy_status: "draft" } };
            }),

    /** OUTBOUNDSMS: poll SMS transcript for Try It Out panel. */
    getOutboundSmsTranscript: ({ workspace_id, customer_phone }) => {
        const params = { workspace_id };
        if (customer_phone !== undefined && customer_phone !== null && customer_phone !== "") {
            params.customer_phone = customer_phone;
        }
        return axios
            .get(`${config.apiBaseURL2}getOutboundSmsTranscript`, { params })
            .then((resp) => resp.data)
            .catch((err) => {
                console.log(err);
                return { status: false, workspace_id, customer_phone: "", from_phone: "", messages: [] };
            });
    },
};

export default botbuilder;
